module.exports = __webpack_public_path__ + "img/appgalery-badge-300.c0557c80.png";